import { useRef, useCallback } from 'react';

export const actions: any = {
    init: 'init',
    nextMonth: 'nextMonth',
    prevMonth: 'prevMonth',
    selectDaysOfWeek: 'selectDaysOfWeek',
};

export function useGetLatest<T extends { [key: string]: any }>(obj: T) {
    const ref = useRef<T>(obj);
    ref.current = obj;
    return useCallback(() => ref.current, []);
}
